import React, { useRef, useState, useEffect, Suspense, startTransition } from 'react';
import classnames from 'classnames';

import { FilterContextProvider } from "./context/context";

import { updateFilterUrl } from './helpers/url';
import { filter_items, filter_items_venues } from './helpers/filters';
import { format_date_datepicker } from './helpers/dates'

const Filters = React.lazy(() => import('./components/Filters'));
const FilterNav = React.lazy(() => import('./components/FilterNav'));
const FilterNavMobile = React.lazy(() => import('./components/FilterNavMobile'));
const TopFilter = React.lazy(() => import('./components/TopFilter'));
const ListView = React.lazy(() => import('./components/ListView'));
const MapView = React.lazy(() => import('./components/MapView'));
const FilterTotals = React.lazy(() => import('./components/FilterTotals'));
const Search = React.lazy(() => import('./components/Search'));

const getRelevantDate = (item) => {
  const now = new Date();

  let dates = Array.isArray(item.performance_dates) ? item.performance_dates : [];

  const upcoming = dates
    .map(date => {
      if (typeof date === 'number') {
        return new Date(date * 1000);
      } else {
        return new Date(parseInt(date) * 1000);
      }
    })
    .filter(date => date instanceof Date && !isNaN(date) && date > now)
    .sort((a, b) => a - b);


  if (upcoming.length > 0) {
    return upcoming[0];
  }

  if (item.end_date) {
    let end;
    if (typeof item.end_date === 'number') {

      end = new Date(item.end_date * 1000);
    } else {
      end = new Date(parseInt(item.end_date) * 1000);
    }

    if (end instanceof Date && !isNaN(end)) {

      return end;
    }
  }

  return null;
};



const FilterUI = props => {
  const {
    items,
    filterForm,
    topFilter,
    filterSettings,
    language
  } = props;

  const isInitialMount = useRef(true);

  const pagination = filterSettings.pagination;

  let allForms = [...filterForm, topFilter];
  allForms = allForms.filter(obj => Object.keys(obj).length !== 0);

  const [filterNav, setFilterNav] = useState(allForms);
  const [totalItems, setTotalItems] = useState(props.items.length);
  const [filterView, setFilterView] = useState(filterSettings.currentView);
  const [activeFilters, setActiveFilters] = useState(filterSettings.activeFilters);
  const [activeFiltersNav, setActiveFiltersNav] = useState(filterSettings.activeFilters);

  const [allItems, setAllItems] = useState(items);
  const [filteredItems, setFilteredItems] = useState(items);
  const [currentPage, setCurrentPage] = useState(filterSettings.pagination.currentPage);
  const [dateRangeSelected, setDateRangeSelected] = useState(false);
  const [dateSelected, setDateSelected] = useState(new Date().setHours(0, 0, 0, 0));
  const [navStatus, setNavStatus] = useState(false);
  const [filterType, setFilterType] = useState('side');

  const [datesMenuStatus, setDatesMenuStatus] = useState(false);
  const [datesMenuOther, setDatesMenuOther] = useState(true);

  const [inProp, setInProp] = useState(false);
  const [opacity, setOpacity] = useState(false);
  const [pagedItems, setPagedItems] = useState([]);

  const [venues, setVenues] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [selectedMarkers, setSelectedMarkers] = useState(filterSettings.map_data ? filterSettings.map_data : []);
  const [viewedMarkers, setViewedMarkers] = useState([]);
  const [startDate, setStartDate] = useState(filterSettings.activeFilters.calendar ? filterSettings.activeFilters.calendar.value[0] : false);
  const [endDate, setEndDate] = useState(filterSettings.activeFilters.calendar ? filterSettings.activeFilters.calendar.value[1] : false);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [startDateFormatted, setStartDateFormatted] = useState(format_date_datepicker(startDate))
  const [endDateFormatted, setEndDateFormatted] = useState(format_date_datepicker(endDate))
  const [dateQuickLink, setDateQuickLink] = useState(false);

  const states = {
    startDate, setStartDate,
    endDate, setEndDate,
    startDateOpen, setStartDateOpen,
    endDateOpen, setEndDateOpen,
    startDateFormatted, setStartDateFormatted,
    endDateFormatted, setEndDateFormatted,
    viewedMarkers, setViewedMarkers,
    selectedMarkers, setSelectedMarkers,
    markers, setMarkers, venues, setVenues,
    filterType, setFilterType,
    activeFiltersNav, setActiveFiltersNav,
    pagedItems, setPagedItems,
    opacity, setOpacity,
    inProp, setInProp,
    datesMenuOther, setDatesMenuOther,
    datesMenuStatus, setDatesMenuStatus,
    allItems, setAllItems,
    filterView, setFilterView,
    filterNav, setFilterNav,
    activeFilters, setActiveFilters,
    totalItems, setTotalItems,
    filteredItems, setFilteredItems,
    pagination,
    currentPage, setCurrentPage,
    dateRangeSelected, setDateRangeSelected,
    dateSelected, setDateSelected,
    language,
    navStatus, setNavStatus,
    dateQuickLink, setDateQuickLink,
  };


  const hasTopFilter = Object.keys(topFilter).length != 0 && topFilter.constructor === Object;
  const hasSearchFilter = Object.keys(topFilter).length != 0 && topFilter.constructor === Object && topFilter.type == "search";

  const viewResults = () => {
    let updatedFilterNav = [...filterNav];

    const scroll1 = document.querySelector('.filter-nav-mobile');
    const scroll2 = document.querySelectorAll('.level-2');

    bodyScrollLock.enableBodyScroll(scroll1);
    scroll2.forEach((element) => {
      bodyScrollLock.enableBodyScroll(element);
    });
    updatedFilterNav.map((nav, i) => {
      if (Object.keys(nav).length != 0) {
        nav.open = false;

      }
    })
    setFilterNav(updatedFilterNav);
    setNavStatus(false);
    const body = document.querySelector('body');
    body.classList.remove('filters-open');
  }

  const updateItems = () => {

    let results = filter_items(items, activeFilters, filterView, selectedMarkers);

    //now get venue filters 
    getVenues(results);

    //now filter by venues
    results = filter_items_venues(results, activeFilters, filterView, selectedMarkers);

    setTotalItems(results.length);
    setFilteredItems(results);
    let totalPageCount = Math.ceil(results.length / pagination.perpage);
    if (currentPage > totalPageCount) {
      setCurrentPage(totalPageCount > 0 ? totalPageCount : 1);
    }
    updateFilterUrl(activeFilters, currentPage, filterView, selectedMarkers);

    console.log(results, 'res');

    const container = document.querySelector('.block-filter-views');

    if (container) {
      const rect = container.getBoundingClientRect();
      window.scrollTo({
        top: rect.top + window.scrollY - 120,
        left: 0,
        behavior: "smooth",
      });
    }

  }

  const setItems = () => {
    let results = filter_items(items, activeFilters, filterView, selectedMarkers);

    getVenues(results);

    results = filter_items_venues(results, activeFilters, filterView, selectedMarkers);

    setTotalItems(results.length);
    setFilteredItems(results);
  }

  const getVenues = (results) => {
    let venues = [];
    for (const key in results) {
      const result = results[key];
      if (result.event_venues) {
        for (const venueId in result.event_venues) {
          const eventVenue = result.event_venues[venueId];
          if (!venues[venueId]) {
            venues[venueId] = {
              name: eventVenue.name,
              lat: eventVenue.lat,
              lng: eventVenue.lng,
              address: eventVenue.address,
              events: []
            };
          }
          venues[venueId].events = [...venues[venueId].events, ...eventVenue.events];
        }
      }
    }

    setVenues(venues);
    // if a venue marker selected then still show other possible markers

    let updated_markers = [];
    if (filter_block == "Events") {
      for (const key in venues) {
        let venue = venues[key];
        let marker = { id: key, lat: parseFloat(venue.lat), lng: parseFloat(venue.lng), title: venue.name, address: venue.address };

        updated_markers.push(marker);
      }
    } else {
      results.forEach((result => {

        if (result.lat && result.lng) {
          let marker = { id: result.name, lat: parseFloat(result.lat), lng: parseFloat(result.lng), title: result.name, address: result.address };
          updated_markers.push(marker);

        }
      }))
    }


    setMarkers(updated_markers);


  }


  const clearAllFilters = () => {
    const a = { ...activeFilters };
    let es = document.getElementById("events-search");
    if (es) {
      es.value = '';
    }
    for (const key in a) {
      if (a[key].position !== "top") {
        if (typeof a[key].value == "object") {
          if (a[key].name == "calendar") {
            a[key].value = [false, false];

          } else {
            a[key].value = [];
            a[key].selectedTitles = [];
          }
        } else {
          a[key].value = "";
        }
      }
    }


    setStartDate(false);
    setStartDateFormatted('Date');
    setEndDate(false);
    setEndDateFormatted('Date');

    setDateRangeSelected(false);
    setActiveFilters(a);
    setSelectedMarkers([]);
    setDateQuickLink(false);
  }

  const toggleFilterDropdown = (type) => {
    const scroll1 = document.querySelector('.filter-nav-mobile');
    const scroll2 = document.querySelectorAll('.level-2');

    if (type == 'side') {
      if (filterType == 'side' && navStatus) {
        setNavStatus(false);
        bodyScrollLock.enableBodyScroll(scroll1);
        scroll2.forEach((element) => {
          bodyScrollLock.enableBodyScroll(element);
        });

      } else {
        setFilterType('side');
        setNavStatus(true);
        bodyScrollLock.disableBodyScroll(scroll1);
        scroll2.forEach((element) => {
          bodyScrollLock.disableBodyScroll(element);
        });
      }
    } else if (type == 'top') {
      if (filterType == 'top' && navStatus) {
        setNavStatus(false);
        bodyScrollLock.enableBodyScroll(scroll1);
        scroll2.forEach((element) => {
          bodyScrollLock.enableBodyScroll(element);
        });
      } else {
        setFilterType('top');
        setNavStatus(true);
        bodyScrollLock.disableBodyScroll(scroll1);
        scroll2.forEach((element) => {
          bodyScrollLock.disableBodyScroll(element);
        });
      }
    } else if (type == 'toggle') {
      if (!navStatus) {
        bodyScrollLock.disableBodyScroll(scroll1);
      } else {
        bodyScrollLock.enableBodyScroll(scroll1);
        scroll2.forEach((element) => {
          bodyScrollLock.enableBodyScroll(element);
        });

      }
      setNavStatus(!navStatus);
      let updatedFilterNav = [...filterNav];
      updatedFilterNav.map((nav, i) => {
        nav.open = false;
      })
      setFilterNav(updatedFilterNav);
    }

  }

  const toggleFilterNav = (widget) => {


    let updatedFilterNav = [...filterNav];

    let any_filters_open = false;

    if (!widget) {
      widget = updatedFilterNav[0];
      updatedFilterNav.map((nav, i) => {

        nav.open = false;
      })

    } else {
      updatedFilterNav.map((nav, i) => {

        if (nav.id === widget.id) {
          nav.open = !widget.open;
        } else {
          nav.open = false;

        }
        if (nav.open) {
          any_filters_open = true;
        }
      })

      setNavStatus(any_filters_open);
    }



    setFilterNav(updatedFilterNav);
  }

  function updateFilterView(event) {
    if (event.target.checked) {
      setFilterView('map');
    } else {
      setFilterView('list');
      setSelectedMarkers([]);
      setViewedMarkers([]);
    }

  }



  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      updateItems();
    }
  }, [activeFilters, currentPage, selectedMarkers, filterView]);

  useEffect(() => {

    if (Array.isArray(items)) {
      const sortedItems = [...items].sort((a, b) => {
        const dateA = getRelevantDate(a);
        const dateB = getRelevantDate(b);
        if (!dateA && !dateB) return 0;
        if (!dateA) return 1;
        if (!dateB) return -1;

        return dateA - dateB;
      });

      setAllItems(sortedItems);
      setFilteredItems(sortedItems);
      getVenues(sortedItems);

      // results = filter_items_venues(results, activeFilters, filterView, selectedMarkers);

      setTotalItems(sortedItems.length);
      setFilteredItems(sortedItems);

      updateItems();



    }
  }, [items]);


  return (
    <>

      <FilterContextProvider value={states}>
        <div className="block-filters-outer">
          <div className="container">
            <div className="block-filters-inner">
              <div
                className={classnames('filter-bg', {
                  active: navStatus
                })}
                onClick={() => viewResults()}></div>

              <div
                className={classnames('block-filters-mobile', {
                  active: navStatus
                })}
              >
                <FilterNavMobile topFilter={topFilter} toggleFilterDropdown={toggleFilterDropdown} toggleFilterNav={toggleFilterNav} clearAllFilters={clearAllFilters} />
                <Filters topFilter={topFilter} filterForm={filterForm} toggleFilterNav={toggleFilterNav} clearAllFilters={clearAllFilters} />
                <div
                  className={classnames('mobile-filter-actions', {
                    active: navStatus
                  })}
                >
                  <FilterTotals />
                  <div className="mobile-filter-actions-buttons">
                    <button class="button button-white button-aqua-hover" onClick={viewResults}>See results</button>
                    <button class="button button-black" onClick={clearAllFilters}>Clear all filters</button>
                  </div>
                </div>
                {hasTopFilter && !hasSearchFilter &&
                  <TopFilter data={topFilter} />
                }
              </div>

              <div

                id="drag_container"
                className={classnames('block-filters-desktop', {
                  active: navStatus
                })}
              >
                <div className="filters">
                  <div className="filter-nav-container">
                    <FilterNav filterForm={filterForm} toggleFilterNav={toggleFilterNav} clearAllFilters={clearAllFilters} viewResults={viewResults} />
                  </div>
                </div>

                <Filters hasTopFilter={hasTopFilter} hasSearchFilter={hasSearchFilter} topFilter={topFilter} toggleFilterNav={toggleFilterNav} clearAllFilters={clearAllFilters} viewResults={viewResults} />


              </div>

              <Suspense>
                <div className="block-filter-views">
                  <div className="block-filter-views-top">

                    {hasTopFilter && hasSearchFilter &&
                      <Search topFilter={topFilter} />
                    }
                    {typeof _filter_maps !== 'undefined' &&
                      <div className="filter-view-toggle">
                        <div className="filter-view-toggle-title font-title font-2">
                          Explore by
                        </div>
                        <div class="switch-wrapper">
                          <span className="switch-label">List</span>
                          <label className="switch">
                            <input
                              type="checkbox"
                              onChange={updateFilterView}
                              checked={filterView == 'list' ? false : true}
                            />
                            <span className="slider round"></span>
                          </label>
                          <span className="switch-label">Map</span>

                        </div>
                      </div>
                    }
                  </div>

                  {hasTopFilter && !hasSearchFilter &&
                    <TopFilter data={topFilter} />
                  }




                  <div className="block-filter-views-inner">

                    {filterView == "list" &&
                      <ListView />
                    }
                    {filterView == "map" &&
                      <MapView />
                    }


                  </div>

                </div>

              </Suspense>
            </div>
          </div>
        </div>
      </FilterContextProvider>

    </>
  );
}
export default FilterUI;
